import { z } from 'zod';
import { zDinero, zId, zPaginacion } from './comunes.js';
/**
 * Panel de productos del cliente (SPEC §6.2): sólo referencias compradas, no expiradas
 * y con imagen. `costo` sólo llega a quien puede verlo (D13): para CLIENTE_VENDEDOR el
 * campo viene ausente, jamás en 0.
 */
export const zProductoCatalogo = z.object({
    id: zId,
    referencia: z.string(),
    nombre: z.string(),
    marcaId: zId,
    marcaNombre: z.string(),
    categoria: z.string(),
    tipo: z.string().nullable(),
    coleccion: z.string().nullable(),
    imagenUrl: z.string(),
    fechaCompra: z.string(),
    cantidadComprada: z.number(),
    costo: zDinero.optional(),
    pvpSugerido: z.number().nullable(),
    precioGuardado: z
        .object({
        metodo: z.enum(['MANUAL', 'PORCENTAJE', 'MULTIPLICADOR', 'SUMA']),
        valorMetodo: z.number().nullable(),
        precioAhora: zDinero,
        precioAntes: zDinero.nullable(),
        estilo: z.enum(['SIMPLE', 'ANTES_AHORA']),
    })
        .nullable(),
});
export const zFiltroCatalogo = zPaginacion.extend({
    marca: zId.optional(),
    categoria: z.string().optional(),
    tipo: z.string().optional(),
    coleccion: z.string().optional(),
    q: z.string().optional(),
});
export const zGuardarPrecios = z.object({
    items: z
        .array(z.object({
        productoId: zId,
        metodo: z.enum(['MANUAL', 'PORCENTAJE', 'MULTIPLICADOR', 'SUMA']),
        valorMetodo: z.number().finite().optional(),
        precioAhora: zDinero.optional(),
        precioAntes: zDinero.nullable().optional(),
        estilo: z.enum(['SIMPLE', 'ANTES_AHORA']).default('SIMPLE'),
    }))
        .min(1)
        .max(500),
});
export const zCalcularPrecios = z.object({
    items: z
        .array(z.object({
        productoId: zId,
        metodo: z.enum(['MANUAL', 'PORCENTAJE', 'MULTIPLICADOR', 'SUMA']),
        valor: z.number().finite(),
    }))
        .min(1)
        .max(500),
});
//# sourceMappingURL=catalogo.js.map